/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Api } from '@axiom/ui';
import { type AreaOfStudy } from '@axiom/domain';
import { CreateAreasOfStudyResponseEntity } from './entities/create-areas-of-study-response-entity';
import { ReadAreasOfStudyResponseEntity } from './entities/read-areas-of-study-response-entity';
import { UpdateAreaOfStudyResponseEntity } from './entities/update-area-of-study-response-entity';

import { type CreateAreasOfStudyRequest } from './dtos/create-areas-of-study-request';
import { type CreateAreasOfStudyResponse } from './dtos/create-areas-of-study-response';
import { type ReadAreasOfStudyResponse } from './dtos/read-areas-of-study-response';
import { type UpdateAreaOfStudyRequest } from './dtos/update-area-of-study-request';
import { EnvUtil } from '../../utils/env-util';

class AreaOfStudyApiClass extends Api {
  constructor() {
    super({ domain: EnvUtil.apiEnvoyUrl });
  }

  /*
   * ────────────────────────────────────────────────────────────────────
   *   /areasOfStudy
   * ────────────────────────────────────────────────────────────────────
   */

  /** Java: AreasOfStudyController.getAll — GET /areasOfStudy */
  readAreasOfStudy() {
    return super.read<{ "data": Array<ReadAreasOfStudyResponse> }>({
      endpoint: '/areasOfStudy',
      method: 'GET',
      schema: { "data": [ReadAreasOfStudyResponseEntity] },
    });
  }

  /** Java: AreasOfStudyController.createAreaOfStudy — POST /areasOfStudy */
  createAreasOfStudy({ body }: { body: CreateAreasOfStudyRequest }) {
    return super.write<{ "data": CreateAreasOfStudyResponse }>({
      endpoint: '/areasOfStudy',
      method: 'POST',
      body,
      schema: { "data": CreateAreasOfStudyResponseEntity },
    });
  }

  /** Java: AreasOfStudyController.getAreaOfStudy — GET /areasOfStudy/{id} */
  readAreaOfStudy({ id }: { id: AreaOfStudy['id'] }) {
    return super.read<{ "data": ReadAreasOfStudyResponse }>({
      endpoint: `/areasOfStudy/${id}`,
      method: 'GET',
      schema: { "data": ReadAreasOfStudyResponseEntity },
    });
  }

  /** Java: AreasOfStudyController.updateAreaOfStudy — PATCH /areasOfStudy/{id} */
  updateAreaOfStudy({ id, body }: { id: AreaOfStudy['id']; body: Partial<UpdateAreaOfStudyRequest> }) {
    return super.write<{ "data": UpdateAreaOfStudyRequest }>({
      endpoint: `/areasOfStudy/${id}`,
      method: 'PATCH',
      body,
      schema: { "data": UpdateAreaOfStudyResponseEntity },
    });
  }
}

export const AreaOfStudyApi = new AreaOfStudyApiClass();
export type { AreaOfStudyApiClass };
